import type { Movie, ResultEntry } from '@filmsloth/shared';
import type { Translate } from '../i18n/index.js';

/** How many places the shared ranking names. Past five nobody reads on. */
export const SHARED_RANKING_LENGTH = 5;

/**
 * The ranking as a message for the group chat.
 *
 * Plain text, one film per line, because it is going into whatever the group
 * already talks in, and every one of those renders plain text; a link to the
 * session would be dead by the time anybody tapped it. Only films somebody
 * actually liked: a top five padded with shrugs is not a recommendation.
 */
export function rankingText(
  results: ResultEntry[],
  t: Translate,
  movieTitle: (movie: Movie) => string,
  limit = SHARED_RANKING_LENGTH,
): string | null {
  const liked = results.filter((entry) => entry.likes > 0).slice(0, limit);
  if (liked.length === 0) return null;

  const lines = liked.map((entry, index) => {
    const title = movieTitle(entry.movie);
    const named = entry.movie.year !== null ? `${title} (${entry.movie.year})` : title;
    const score = entry.score > 0 ? `+${entry.score}` : String(entry.score);
    return `${index + 1}. ${named} · ${t('results.points', { count: score })}`;
  });
  return [t('ranking.shareHeader'), ...lines].join('\n');
}
